import { createContext, useContext, useEffect, useState }  from 'react';
import { useNavigate } from 'react-router-dom';

import { observer } from 'mobx-react-lite';
import { RootStoreContext, TransportLayerUpdateType } from "stores/root_store";

import { MessageProps } from "stores/messages_store";
import { Message } from 'components/FancyToast';
//import useIdentity from 'hooks/useIdentity';
import useUserIdentity from 'hooks/useUserIdentity';

import { forageGet } from 'utils/misc';

export type RealtimePacketType = {
	envelope: {
		key: string;
        notification?: string;
	};
	meta: {
		type: string;
        uuid: string;
	};
	payload : MessageProps;
}

export type RealtimeContextType = {
	forwardUpdate: (event: RealtimePacketType) => void,
    playDing: () => void,
    //    knownUpdates?: string[],
}



const RealtimeContext = createContext<RealtimeContextType>({
    forwardUpdate: () => { throw "not implemented" },
    playDing: () => { throw "not implemented" },
});


function associated_url(associated_type: string, associated_uuid: string) {
    if (associated_type == "chat_room") {
        return `/chat/${associated_uuid}`;
    }
    return `/${associated_type}/${associated_uuid}`;
}

const RealtimeProvider = observer(({ children }: { children: React.ReactNode  })=> {

    const navigate = useNavigate();
    const { currentIdentity } = useUserIdentity();
    const [playAudio, setPlayAudio] = useState(true);
	const rootStore = useContext(RootStoreContext);

    useEffect(() => {
        forageGet('play-sound').then((res) => {
            if (res === null || res === true) {
                console.log("Setting playAudio to true");
                setPlayAudio(true);
            }
            else {
                console.log("Setting playAudio to false");
                setPlayAudio(false);
            }

        });
    }, []);

    const playDing = () => {
        /* play audio */
        if (playAudio) {
            console.log("Playing audio");
            const dingAudio = new Audio('/sound/ding-01.mp3');
            dingAudio.play();
        }
        else {
            console.log("Not playing sound");
        }
    }

    const forwardUpdate = (data: RealtimePacketType) => {


        const type = data.meta.type as string;

        /* Forward the update to the root store to update the lists/etc. */
        rootStore.forwardUpdate(type, data.payload as TransportLayerUpdateType);

        // const notification = data.envelope.notification;

        /* We already forwarded the update, but let's show the
           notification if we need to. */
        if (!['request_message', 'message'].includes(data.meta.type)) {
            // console.log("not showing notification on type", data.meta.type);
            return;
        }
        // console.log("Showing notification");
        const message = data.payload as MessageProps;
        // console.log("Message: %o", message);
        // console.log('data: %o', data);

        // unless we sent it (check both key and uuid for compatibility)
        if (message.identity != currentIdentity.uuid && message.identity != currentIdentity.key) {

            console.log("Message: %o", message);
            console.log('data: %o', data);

            // make a noise
            playDing();

            /* we're already on the right page */
            if (message.collab && location.pathname.endsWith(message.collab)) {
                return;
            }
            else if (message.request && location.pathname.endsWith(message.request)) {
                return;
            }



            /* OK, show the message (in the webpage itself) */
            const onClick = () => {
                if(data.meta.type == "request_message" && message.request) {
                    navigate(`/request/${message.request}`);
                }
                else {
                    if(data.payload.associated_type && data.payload.associated_uuid) {
                        const url = associated_url(
                            data.payload.associated_type,
                            data.payload.associated_uuid
                        );
                        navigate(url);
                    }
                    else {
                        navigate('/collab/' + message.collab);
                    }
                }
            }
            Message(message.content, message.identity, "See More", onClick);
        }
        else {
            console.log("we sent this message, not showing notification");
        }

    }; // , [currentIdentity, navigate, playAudio, receivedMessages.length]);


    const data = {
        forwardUpdate,
        playDing
    }
    return (
        <RealtimeContext.Provider value={data}>
            { children }
        </RealtimeContext.Provider>
    )

});

export { RealtimeContext, RealtimeProvider };
